import { render, staticRenderFns } from "./ReactivationBcc.vue?vue&type=template&id=35eec059&"
import script from "./ReactivationBcc.vue?vue&type=script&lang=ts&"
export * from "./ReactivationBcc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports